// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__b6K9O","breadcrumbLink":"Breadcrumbs_breadcrumbLink__mkaY7"};